export default __webpack_public_path__ + "static/media/shiny-new-flat.509eeadb.svg";